var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInforoundedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "#F4F4F7",
    stroke: "#919191"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5938 5.91406V14.5078H12.4062V5.91406H14.5938ZM13.5 16.2266C13.9297 16.2266 14.2943 16.3828 14.5938 16.6953C14.9062 16.9948 15.0625 17.3594 15.0625 17.7891C15.0625 18.2188 14.9062 18.5898 14.5938 18.9023C14.2943 19.2018 13.9297 19.3516 13.5 19.3516C13.0703 19.3516 12.6992 19.2018 12.3867 18.9023C12.0872 18.5898 11.9375 18.2188 11.9375 17.7891C11.9375 17.3594 12.0872 16.9948 12.3867 16.6953C12.6992 16.3828 13.0703 16.2266 13.5 16.2266Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInforoundedIcon);
export default __webpack_public_path__ + "static/media/inforounded-icon.3caae0c709b09e78267afcce3e9c8ca9.svg";
export { ForwardRef as ReactComponent };